module.exports = __webpack_public_path__ + "img/3.2eb14868.png";